import { useEffect } from "react";
import { useTab } from "../../store/useTab";
import { Content } from "./Content";
import { LayoutDashboard } from "lucide-react";

export function Dashboard() {
  const setCurrentTab = useTab((store) => store.setTab);

  useEffect(() => {
    setCurrentTab("Início");
  }, [setCurrentTab]);

  return (
    <>
      <header className="mb-8 border-b border-zinc-200/80 pb-6 dark:border-zinc-800">
        <div className="flex flex-col gap-1 sm:flex-row sm:items-end sm:justify-between">
          <div className="flex items-start gap-3">
            <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-apcap-muted text-apcap ring-1 ring-apcap/10 dark:bg-apcap/15 dark:text-emerald-300 dark:ring-white/10">
              <LayoutDashboard className="h-5 w-5" aria-hidden />
            </span>
            <div>
              <h1 className="text-2xl font-semibold tracking-tight text-zinc-900 dark:text-white sm:text-3xl">
                Dashboard
              </h1>
              <p className="mt-1 max-w-xl text-sm leading-relaxed text-zinc-600 dark:text-zinc-400">
                Visão geral dos eventos, indicadores e acesso rápido ao que
                importa.
              </p>
            </div>
          </div>
        </div>
      </header>
      <Content />
    </>
  );
}
